import { useEffect } from 'react'
import { useI18n } from '../i18n/useI18n'

export function PublicPageMeta({ title, description, schema }: { title: string; description: string; schema?: Record<string, unknown> }) {
  const { locale, t } = useI18n()
  useEffect(() => {
    document.title = `${t(title)} | PropertyReady`
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.append(meta) }
    meta.content = t(description)
    let script = document.querySelector<HTMLScriptElement>('#propertyready-public-schema')
    if (schema) {
      if (!script) { script = document.createElement('script'); script.id = 'propertyready-public-schema'; script.type = 'application/ld+json'; document.head.append(script) }
      script.text = JSON.stringify(schema)
    }
    return () => { script?.remove() }
  }, [description, locale, schema, t, title])
  return null
}
